import React from "react";

import { EMPTY_ARRAY } from "@multiweb/reactUtils";
import { AttributeComponent } from "../../../../components";
import { LOVAttribute } from "../../../components/LOVAttribute";
import { IDataSourceLOVAttribute } from "../types";
import { createOpenEditWindowParams } from "../utils";

export const LiteListFrameLOVAttribute: AttributeComponent = ({
    dataSourceKey,
    recordId,
    record,
    dataSourceAttribute,
    dataSourceAttributeInfo,
    interactive,
}) => {
    if (!record || !dataSourceAttribute || !dataSourceAttributeInfo || !(dataSourceAttribute instanceof IDataSourceLOVAttribute)) {
        return null;
    }

    const { attributeName, editWindow } = dataSourceAttribute;
    const displayFormat = dataSourceAttribute.displayFormat ?? undefined;
    const showAttrs = dataSourceAttribute.showAttrs ?? EMPTY_ARRAY as string[];

    const openEditWindowParams = createOpenEditWindowParams(
        dataSourceKey,
        recordId,
        record?.[attributeName]?.value,
        showAttrs,
        editWindow,
    );

    return (
        <LOVAttribute
            key={recordId}
            {...{
                dataSourceKey,
                recordId,
                record,
                attributeName,
                showAttrs,
                dataSourceAttributeInfo,
                displayFormat,
                interactive,
                openEditWindowParams,
            }}
        />
    );
};
